import { connectToStores } from 'fluxible-addons-react';
import BriefStore from 'contest/stores/brief-store';

import ScoreSummary from 'contest/components/brief/score-summary';

const ConnectedScoreSummary = connectToStores(ScoreSummary, [BriefStore], (context, props) => {
    const store = context.getStore(BriefStore);
    return {
        score: store.score.total,
        nextElement: store.getNextScoringElement(),
    };
});

export default ConnectedScoreSummary;



// WEBPACK FOOTER //
// ./src/web/js/contest/components/connected/connected-score-summary.jsx